import styled from 'styled-components';

export const WarningContainer = styled.div`
  border-radius: 8px;
  background: rgba(98, 90, 99, 0.5);
  padding: 8px;
  max-height: 40px;
  display: flex;
  align-items: center;
`;
